<template>
  <div class="page_box">
    <BaseBanner :bannerInfo.sync="bannerInfo"></BaseBanner>
    <BaseModule :moduleInfo.sync="moduleInfo1">
      <ul class="module_body module_body_1">
        <div id="map" class="map"></div>
        <div class="module_item_1">
          <li class="flex_items" v-for="(item,index) in list1" :key="index+'_1'">
            <img :src="item.img" alt />
            <span>{{item.text}}</span>
          </li>
        </div>
      </ul>
    </BaseModule>
  </div>
</template>
<script>
export default {
  data() {
    return {
      bannerInfo: {
        img: require("@img/contact/banner.png"),
        desc: {
          title: this.$t("contact.bannerTitle"),
          text: this.$t("contact.text1"),
        },
      },
      moduleInfo1: {
        title: this.$t("contact.module1.title"),
        desc: {
          text1: "",
        },
      },
      list1: [
        {
          img: require("@img/contact/icon1_contact.png"),
          text: this.$t("contact.moduleList1.phone"),
        },
        {
          img: require("@img/contact/icon1_contact.png"),
          text: this.$t("contact.moduleList1.email"),
        },
        {
          img: require("@img/contact/icon1_contact.png"),
          text: this.$t("contact.moduleList1.text1"),
        },
        {
          img: require("@img/contact/icon2_contact.png"),
          text: this.$t("contact.moduleList1.text2"),
        },
      ],
    };
  },
  mounted() {

    // 百度地图API功能
    var map = new AMap.Map("map", {
      lang: sessionStorage.getItem("language")
        ? sessionStorage.getItem("language") == "zh"
          ? "zh_cn"
          : "en"
        : "zh_cn",
      zoom: 20, //初始地图级别
      center: [121.246429, 31.059285], //初始地图中心点
    }); // 创建Map实例

    // 创建点覆盖物
    var marker = new AMap.Marker({
      position: new AMap.LngLat(121.246429, 31.059285),
      icon:
        "//a.amap.com/jsapi_demos/static/demo-center/icons/poi-marker-default.png",
      offset: new AMap.Pixel(-10, -40),
    });

    map.add(marker);

    // map.centerAndZoom(new AMap.Point(121.402865, 31.13626), 20); // 初始化地图,设置中心点坐标和地图级别
    // map.setCurrentCity("上海"); // 设置地图显示的城市 此项是必须设置的
    // map.enableScrollWheelZoom(true); //开启鼠标滚轮缩放

    // var marker = new AMap.Marker(new AMap.Point(121.402865, 31.13626)); // 创建标注
    // map.addOverlay(marker);
  },
};
</script>

<style lang="less" scoped>
.page_box {
  .module_body_1 {
    .map {
      width: 100%;
      height: 380px;
      margin-bottom: 20px;
    }

    .module_item_1 {
      font-size: 16px;
      color: @fontColorDesc;
      letter-spacing: 0;
      line-height: 42px;

      img {
        margin-right: 10px;
      }
    }
  }
}
</style>
